import { render, staticRenderFns } from "./MobileOrderStoreFront.vue?vue&type=template&id=5a2d7458&"
import script from "./MobileOrderStoreFront.vue?vue&type=script&lang=js&"
export * from "./MobileOrderStoreFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports